export enum Roles {
  SUPER_ADMIN = 'super-admin',
  AGENCY_ADMIN = 'agency-admin',
  CONTENT_CREATOR = 'content-creator',
  INTERNAL_APPROVER = 'internal-approver',
  EXTERNAL_APPROVER = 'external-approver'
}

export default Roles
